<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px;">
      <span>收入信息</span>
      <div style="float: right;" v-if="!IsDetail">
        <!-- <el-button type="primary" icon="el-icon-plus" @click="addRow">添加</el-button> -->
      </div>
    </div>
    <el-table border class="tb-c-head" :data="Data" @row-click="rowClick" show-summary  :summary-method="getSummaries">
      <el-table-column type="index" label="序号" width="50" align="center" />
      <el-table-column prop="IncomeName" label="收入名称" min-width="110">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.IncomeName}}</span>
          <income-select
            v-else
            v-model="row.IncomeName"
            :source="DIncome"
            @select="onSelect($event,row)"
            @inputText="inputText($event,row)"
                @click.native="resetFun(row)" 
                @currentPage="currentPage($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal='listTotal'
                :pageType='true'
          />
        </template>
      </el-table-column>
      <el-table-column prop="IncomeCode" label="收入编号" min-width="110" />
      <el-table-column prop="Amount" label="金额">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.Amount}}</span>
          <el-input v-else @input="onInput(row,'Amount')" v-model="row.Amount"></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="WriteoffAmount" label="累计结款金额" min-width="110px">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.WriteoffAmount}}</span>
          <el-input v-else @input="onInput(row,'WriteoffAmount')" v-model="row.WriteoffAmount"></el-input>
        </template>
      </el-table-column>-->
      <el-table-column prop="Remark" label="备注" width="200px">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.Remark}}</span>
          <el-input v-else type="textarea" autosize @input="onInput(row)" v-model="row.Remark"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="95" fixed="right" v-if="!IsDetail">
        <template slot-scope="{row,$index}">
          <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link>
          <el-link @click="delRow(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import incomeSelect from "@/components/basedoc/income/select";
// import incomeSelect from "@/components/common/selectInput";

export default {
  components: { incomeSelect },
  props: {
    IsDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      income_api: require("@/api/sale/income").default,
      Data: [
        {
        DocDtsId: 0,
        DocId: 0,
        IncomeId: 0, //收入
        IncomeCode: "",
        IncomeName: "",
        Amount: null, //金额
        // TaxRate: null, //税率
        // TaxAmount: null, //税额
        // IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        WriteoffAmount: 0, //累计结款金额
        Remark: "",
        T: 0,
      }
      ],
      DelData: [],
      DIncome: [],
      isMB: this.$store.state.isMB,
      initDAccount:[],  
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      listTotal:0,
    };
  },
  methods: {
    resetFun(row){

      //if(!row.IncomeName){
        this.pageParams.pageIndex=1
        this.DIncome=this.initDAccount
        this.listTotal=this.initTotal
      //}


    },
    currentPage(val, row){
      let IncomeName = row.IncomeName;
      this.pageParams.pageIndex=val
          this.income_api.list({ Status: 1,pageIndex: val,pageSize:7, IncomeName }).then((res) => {
            if (res.Code == 0) {
            this.DIncome = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    inputText(text, row){
      if (text == row.IncomeName) {
        //console.log("相同", text);
        return;
      }
      row.IncomeName = text;
      this.income_api.list({ Status: 1,pageIndex: 1,pageSize:7,IncomeName:text}).then((res) => {
        if (res.Code == 0) {this.DIncome = res.Data;this.listTotal=res.Count}
      });
    },
     getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 3) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2)) ;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
        rowClick(row) {
       if(!this.IsDetail){
          var index = this.Data.indexOf(row);
          if (index + 1 == this.Data.length) {
            // 
            this.addRow();
          }
       }
    },
    setIncome(data) {
      this.DIncome = data.Data;
      this.initDAccount=data.Data;
      this.initTotal=data.length
    },
    setData(data) {
      
      this.Data = data;
    },
    getData() {
      var data = this.Data.filter((x) => x.T != null);
      this.DelData.forEach((x) => data.push(x));
      return data;
    },
    addRow() {
      this.Data.push({
        DocDtsId: 0,
        DocId: 0,
        IncomeId: 0, //收入
        IncomeCode: "",
        IncomeName: "",
        Amount: null, //金额
        // TaxRate: null, //税率
        // TaxAmount: null, //税额
        // IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        // WriteoffAmount: 0, //累计结款金额
        Remark: "",
        T: 0,
      });
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      // if (type) row[type] = this.$commonJs.obj.toNumber(row[type]);
    },
    onSelect(e, row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row.IncomeId = e.IncomeId;
      row.IncomeCode = e.IncomeCode;
      row.IncomeName = e.IncomeName;
    },
    delRow(row, index) {
      if (row.T != 0) this.DelData.push({ ...row, T: 2 });
      this.Data.splice(index, 1);
    },
    copyRow(row) {
      this.Data.push({ ...row, T: 0 });
    },
    clear() {
      this.Data = [];
      this.DelData = [];
      this.DIncome = [];
    },
  },
};
</script>